import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const distanceLearningTimetable: ApiFunc<`${typeof API.DISTANCE_LEARNING_TIMETABLE}`, 'get'> = data =>
  instance.get(API.DISTANCE_LEARNING_TIMETABLE, { params: data })

// export const timetableUpdated: ApiFunc<`${typeof API.TIMETABLE_UPDATED}`, 'get'> = data =>
//   instance.get(API.TIMETABLE_UPDATED, { params: data })

export const distanceLearningTimetableAll: ApiFunc<`${typeof API.DISTANCE_LEARNING_TIMETABLE_ALL}`, 'get'> = data =>
  instance.get(API.DISTANCE_LEARNING_TIMETABLE_ALL, { params: data })

// export const timetableGenerate: ApiFunc<`${typeof API.TIMETABLE_GENERATE_UPDATED}`, 'post'> = data =>
//   authorizedInstance.post(API.TIMETABLE_GENERATE_UPDATED, data)

export const distanceLearningTimetableGenerateUpdated: ApiFunc<
  `${typeof API.DISTANCE_LEARNING_TIMETABLE_GENERATE_UPDATED}`,
  'post'
> = data => instance.post(API.DISTANCE_LEARNING_TIMETABLE_GENERATE_UPDATED, data)

export const distanceLearningTimetableUpdateStatus: ApiFunc<
  `${typeof API.DISTANCE_LEARNING_TIMETABLE_UPDATE_STATUS}`,
  'put'
> = data => instance.put(API.DISTANCE_LEARNING_TIMETABLE_UPDATE_STATUS, data)

export const distanceLearningTimetableHoursReport: ApiFunc<
  `${typeof API.DISTANCE_LEARNING_TIMETABLE_HOURS_REPORT}`,
  'post'
> = data => instance.post(API.DISTANCE_LEARNING_TIMETABLE_HOURS_REPORT, data, { responseType: 'blob' })
